import React from 'react';
import { useViewChangeTracker } from '../../../hooks/useViewChangeTracker';
import AssociationAnalyticsDashboard from '../GdaAnalytics/AssociationAnalyticsDashboard';

function DDAGraphs({ source, view, names }) {
  useViewChangeTracker('DDAGraphs', view, 'graph');

  return <AssociationAnalyticsDashboard associationTab="DDA" source={source} view={view} names={names} />;
}

export default React.memo(DDAGraphs);
